import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styles: []
})
export class ExpenseComponent implements OnInit {

  loadingIndicator: boolean;

  constructor(private jhiLanguageService: JhiLanguageService) {
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.jhiLanguageService.setLocations(['expense']);
    this.loadingIndicator = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/expense/components/expense/expense.component.ts